/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './referencelistoptout.defs'
export { main as default } from './referencelistoptout.defs'
